import { colors } from "@asurion-core/mx-asurion-ui-react";
import { Avatar, ClientTag, Contact, DetailsContainer, DetailsWrapperContainer, HighlightText } from "@ubif/components";
import styled from "styled-components";

import { FlexContactWrapperContainer } from "./FlexContainers";

export interface QuickSearchCustomerDetailsProps {
  customerId: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email?: string;
  phone?: string;
  canSms?: boolean;
  canCall?: boolean;
  canEmail?: boolean;
  highlightText: string;
  preferredContactLabel: string;
  storeTimeZone?: string;
  onClick: (id: string, clientId?: number, customerTypeId?: number) => void;
  clientId?: number;
  customerTypeId?: number;
}

export const QuickSearchCustomerDetails = ({
  customerId,
  firstName,
  lastName,
  fullName,
  email,
  phone,
  canSms,
  canCall,
  canEmail,
  highlightText,
  preferredContactLabel,
  clientId = 1,
  onClick,
  customerTypeId
}: QuickSearchCustomerDetailsProps) => {
  const handleClick = () => {
    onClick(customerId, clientId, customerTypeId);
  };

  return (
    <StyledQuickSearchCustomerDetails onClick={handleClick}>
      <Avatar
        firstName={firstName}
        lastName={lastName}
        height={1.25}
        width={1.25}
        fontSize={0}
        backgroundColor={`${colors.primaryBrighter}4D`}
        textColor={colors.neutralDeepest}
      />
      <DetailsContainer>
        <HighlightText highlightText={highlightText} wholeText={fullName} className="fs-mask" />
        <ClientTag clientId={clientId} />
        <FlexContactWrapperContainer>
          {email ? (
            <Contact
              icon="email"
              text={email}
              canEmail={canEmail}
              preferredContactLabel={preferredContactLabel}
              className="fs-mask"
            />
          ) : null}
          {phone ? (
            <Contact
              icon="call"
              text={phone}
              canCall={canCall}
              canSms={canSms}
              preferredContactLabel={preferredContactLabel}
              className="fs-mask"
            />
          ) : null}
        </FlexContactWrapperContainer>
      </DetailsContainer>
    </StyledQuickSearchCustomerDetails>
  );
};

const StyledQuickSearchCustomerDetails = styled(DetailsWrapperContainer)`
  background-color: var(--aui-elevated-level-01);
  color: var(--aui-on-surface);

  &:hover {
    background-color: var(--aui-outline-soft);
    border-radius: 0.5rem;
    cursor: pointer;
  }
`;
